import React, { FC, useState, useEffect, useRef } from 'react'
import './index.scss'

import tigerImg from '@img/mkt/tiger-img.png'

interface IProps {
  startType: boolean;
  result?: string;
  onStop?: () => void;
}

const Tiger: FC<IProps> = (props: IProps) => {
  const { startType, result, onStop } = props
  const ref0: any = useRef<any>(null)
  const ref1: any = useRef<any>(null)
  const ref2: any = useRef<any>(null)
  const [isBegin, setIsBegin] = useState<boolean>(false)
  const [preNum, setPreNum] = useState<any>([0, 0, 0])
  const ImgNum: number = 9
  const loop: number = 4
  const itemH: number = 104
  const boxH: number = loop * ImgNum * itemH
  const numRand = () => {
    const rand: any = []
    const randomNum = () => {
      let num = Math.floor(Math.random() * ImgNum)
      if (!rand.includes(num) || rand.length !== 2) {
        rand.push(num)
      }
      if (rand.length < 3) {
        randomNum()
      }
    }
    randomNum()
    return rand
  }
  // Component Effect
  useEffect(() => {
    if (startType && !isBegin) {
      setIsBegin(true)
      const num_arr = (result === 'success') ? [0, 0, 0] : numRand()
      const pre_arr = preNum
      const numDom = [ref0.current, ref1.current, ref2.current]
      for (let i = 0; i < numDom.length; i++) {
        numDom[i].style.transition = 'none'
        const inter = parseInt(pre_arr[i])
        numDom[i].style.transform = `translateY(${-boxH + inter * itemH + itemH}px)`
      }
      for (let i = 0; i < numDom.length; i++) {
        setTimeout(() => {
          let zInter
          if (parseInt(pre_arr[i]) === 0) {
            zInter = num_arr[i]
          } else {
            zInter = num_arr[i] + (ImgNum - parseInt(pre_arr[i]))
          }
          const posY = numDom[i].style.transform
          const numPosY = parseFloat(posY.substring(11, posY.length - 2))
          const pos = numPosY + itemH * ImgNum * (loop - 2) + itemH * zInter
          numDom[i].style.transition = 'all 4s cubic-bezier(0.31, 0.09, 0.82, 1.04)'
          numDom[i].style.transform = `translateY(${pos}px)`
        }, (i + 0.1) * 500)
      }
      const endTime = 300 * (numDom.length - 1) + 4500
      setPreNum(num_arr)
      setTimeout(() => {
        setIsBegin(false)
        onStop && onStop()
      }, endTime)
    }
  }, [startType])
  return (
    <div className='new-tiger-main'>
      <div className='tiger-item'>
        <div
          className='item-block' ref={ref0} style={{
            transform: `translateY(${-boxH + itemH}px)`
          }}
        >
          {
            [...Array(loop)].map(() => {
              return (
                [...Array(9)].map((cItem: any, cIndex: number) => {
                  return (
                    <div
                      className='img-block'
                      key={cIndex}
                    >
                      <div
                        className='img'
                        style={{
                          backgroundImage: `url(${tigerImg})`,
                          backgroundPosition: `0px -${itemH * (9 - cIndex - 1)}px`
                        }}
                      >
                      </div>
                    </div>
                  )
                })
              )
            })
          }
        </div>
      </div>
      <div className='tiger-item'>
        <div
          className='item-block' ref={ref1} style={{
            transform: `translateY(${-boxH + itemH}px)`
          }}
        >
          {
            [...Array(loop)].map(() => {
              return (
                [...Array(9)].map((cItem: any, cIndex: number) => {
                  return (
                    <div
                      className='img-block'
                      key={cIndex}
                    >
                      <div
                        className='img'
                        style={{
                          backgroundImage: `url(${tigerImg})`,
                          backgroundPosition: `0px -${itemH * (9 - cIndex - 1)}px`
                        }}
                      >
                      </div>
                    </div>
                  )
                })
              )
            })
          }
        </div>
      </div>
      <div className='tiger-item'>
        <div
          className='item-block' ref={ref2} style={{
            transform: `translateY(${-boxH + itemH}px)`
          }}
        >
          {
            [...Array(loop)].map(() => {
              return (
                [...Array(9)].map((cItem: any, cIndex: number) => {
                  return (
                    <div
                      className='img-block'
                      key={cIndex}
                    >
                      <div
                        className='img'
                        style={{
                          backgroundImage: `url(${tigerImg})`,
                          backgroundPosition: `0px -${itemH * (9 - cIndex - 1)}px`
                        }}
                      >
                      </div>
                    </div>
                  )
                })
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default Tiger
